<template>
    <div class="modal-confirmation-dialog">
        <p class="modal-confirmation-dialog__description" v-html="text"></p>
        <div class="modal-confirmation-dialog__buttons">
            <TotemButton @click="$modal.hide('confirmation-dialog')" :label="buttonNoLabel"></TotemButton>
            <TotemButton @click="onYesClick" :label="buttonYesLabel" color="primary"></TotemButton>
        </div>
    </div>
</template>

<script>
export default {
    props: ['text', 'onYes', 'buttonYesLabel', 'buttonNoLabel'],
    methods: {
        onYesClick() {
            this.onYes()
            this.$modal.hide('confirmation-dialog')
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-confirmation-dialog {
    font-family: PlusJakartaSans-Regular, sans-serif;
    font-size: 1.6rem;
    padding: 10px;

    &__description {
        font-size: 1.6rem;
        line-height: 150%;
        margin-bottom: 20px;
    }

    &__buttons {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;

        @media (min-width: 576px) {
            flex-direction: row;
            justify-content: flex-end;;

            .totem-button.medium {
                font-size: 1.8rem;
                min-height: 41px;
                height: 100%;
            }
        }
    }
}
</style>
